// A phone browser stops timers when it goes to the background, so the live
// heartbeat stops and the mentor drops offline within 90 seconds. Going live
// is desktop only until there is native push (Foti, 2026-09-23).
export const isPhoneBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false
  const hinted = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData?.mobile
  if (typeof hinted === 'boolean') return hinted
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
}
